import React, { memo } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Box, Flex, Image } from '@chakra-ui/react';
import appConfig from '../../../../config/app-config';
import ColorLaunchdeckLogo from '../../../layout/components/header/styles/images/launchdeck_logo.svg';
import brandLabel from '../../../digital-sales-room/styles/images/ld_brand_label.svg'


function LaunchdeckBrandingLabel({showLaunchdeckBranding, isMobileView}) {

  const handleClickBrandLabel = () => {
    window.location.href = appConfig.landingPage
  }

  if (showLaunchdeckBranding) {
    if (!!isMobileView) {
      return (
        <Flex position='sticky' w='100%' justify='center'>
          <Flex cursor='pointer' w='100%' justify='center' fontSize='0.7em' onClick={() => handleClickBrandLabel()}>
            Powered by
            <Image src={ColorLaunchdeckLogo} maxW='7em' ml='0.5em' alt="Launchdeck brand label" />
          </Flex>
        </Flex>
      )
    } else {
      return (
        <Box position='fixed' bottom='1em' left='2em'>
          <Flex w='100%' justify='center'>
            <Flex cursor='pointer' w='100%' onClick={() => handleClickBrandLabel()}>
              <Image src={brandLabel} maxW='14em' alt="Launchdeck brand label" mx='auto' />
            </Flex>
          </Flex> 
        </Box>
      )
    }
  } else return null;

 
}


const mapStateToProps = (state) => ({
  isMobileView: state.mobileViewMode.isMobileView,
  showLaunchdeckBranding: state.showLaunchdeckBranding.results
})



export default memo(withRouter(connect(mapStateToProps, null)(LaunchdeckBrandingLabel)))
